import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BedTypeService from "../../services/bedType.service";

// **Async Thunks**
export const addbedType = createAsyncThunk(
  "bedType/addbedType",
  async (item, thunkAPI) => {
    try {
      const response = await BedTypeService.addBedType(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getbedType = createAsyncThunk(
  "bedType/getbedType",
  async (item, thunkApi) => {
    try {
      const response = await BedTypeService.getBedType(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editbedType = createAsyncThunk(
  "bedType/editbedType",
  async (item, thunkAPI) => {
    try {
      const response = await BedTypeService.editBedType(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletebedType = createAsyncThunk(
  "bedType/deletebedType",
  async (id, thunkAPI) => {
    try {
      await BedTypeService.deleteBedType(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  bedTypes: [],
};

// **Slice**
const bedTypeSlice = createSlice({
  name: "bedType",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Bed Type List**
      .addCase(getbedType.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getbedType.fulfilled, (state, action) => {
        state.loading = false;
        state.bedTypes = action.payload;
      })
      .addCase(getbedType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Bed Type**
      .addCase(addbedType.pending, (state) => {
        state.loading = true;
      })
      .addCase(addbedType.fulfilled, (state, action) => {
        state.loading = false;
        state.bedTypes.push(action.payload);
      })
      .addCase(addbedType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Bed Type**
      .addCase(editbedType.pending, (state) => {
        state.loading = true;
      })
      .addCase(editbedType.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.bedTypes.findIndex((b) => b.id === action.payload.id);
        if (index !== -1) {
          state.bedTypes[index] = action.payload;
        }
      })
      .addCase(editbedType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Bed Type**
      .addCase(deletebedType.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletebedType.fulfilled, (state, action) => {
        state.loading = false;
        state.bedTypes = state.bedTypes.filter((b) => b.id !== action.payload);
      })
      .addCase(deletebedType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default bedTypeSlice.reducer;
